export const REP_COLORS = {
  peter: '#3ea4b1', mitch: '#7F77DD', jared: '#1D9E75', sarah: '#D4537E',
  dan: '#EF9F27', barry: '#888780', justin: '#5DCAA5', kelsey: '#F0997B',
};

export const REP_META = [
  { id:'peter',  name:'Peter Povey',    initials:'PP', color: REP_COLORS.peter },
  { id:'mitch',  name:'Mitch Jankowski',initials:'MJ', color: REP_COLORS.mitch },
  { id:'jared',  name:'Jared Gavard',   initials:'JG', color: REP_COLORS.jared },
  { id:'sarah',  name:'Sarah Sutter',   initials:'SS', color: REP_COLORS.sarah },
  { id:'dan',    name:'Dan Pena',       initials:'DP', color: REP_COLORS.dan   },
  { id:'barry',  name:'Barry-Lynn',     initials:'BL', color: REP_COLORS.barry },
  { id:'justin', name:'Justin Gavard',  initials:'JG', color: REP_COLORS.justin},
  { id:'kelsey', name:'Kelsey Gavard',  initials:'KG', color: REP_COLORS.kelsey},
];

export function fmt(n) {
  return '$' + Math.round(n).toLocaleString();
}

export function fmtDec(n) {
  if (isNaN(n)) return '$0.00';
  return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function parseMoney(str) {
  if (typeof str === 'number') return str;
  return parseFloat(String(str || '0').replace(/[$,]/g, '')) || 0;
}

export const GC = 'rgba(0,0,0,0.05)';
export const TC = '#9ca3af';

export function chartDefaults() {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
  };
}

export function MetricCard({ label, value, sub, valueStyle }) {
  return (
    <div className="metric-card">
      <div className="metric-label">{label}</div>
      <div className="metric-value" style={valueStyle}>{value}</div>
      {sub && <div className="metric-sub">{sub}</div>}
    </div>
  );
}

export function BarList({ items, maxVal, isMoney }) {
  return (
    <div className="bar-list">
      {items.map(([name, val], i) => {
        const pct = maxVal > 0 ? (val / maxVal * 100).toFixed(1) : 0;
        const label = isMoney ? '$' + Math.round(val).toLocaleString() : Number(val).toLocaleString();
        return (
          <div className="bar-row" key={i}>
            <span className="bar-rank">{i + 1}</span>
            <span className="bar-name" title={name}>{name}</span>
            <div className="bar-track"><div className="bar-fill" style={{ width: pct + '%' }} /></div>
            <span className="bar-val">{label}</span>
          </div>
        );
      })}
    </div>
  );
}
